import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import BellNotifiaction from '../BellNotifiaction';
import Modal from "react-modal";

Modal.setAppElement("#root");
export default function Team() {
    const [fname5, setfname5] = useState("");
    const [firstName, setfirstName] = useState("");
    const [newFile5, setNewFile5] = useState(null);
    const [newdata5, setnewdata5] = useState([]);
     console.log(newdata5)
     const [isModalOpen, setIsModalOpen] = useState(false);
     const [selectedImage, setSelectedImage] = useState("");
     
     const handleImageClick = (imageSrc) => {
       setSelectedImage(imageSrc);
       setIsModalOpen(true);
     };
     
     const handleCloseModal = () => {
       setIsModalOpen(false);
     };
  
    const setData5 = (e) => {
      const { value } = e.target;
      setfname5(value);
     
    };
    const setData9 = (e) => {
      const { value } = e.target;
      setfirstName(value);
     
    };
    const setimgfile = (e) => {
      setNewFile5(e.target.files[0]);
    };
  
    // Add image
  
    const adduserData5 = async (e) => {
      
      var formData5 = new FormData();
      console.log(newFile5);
      var filename = newFile5.name;
      formData5.append("photo5", newFile5, filename);
      formData5.append("fname5", fname5);
      formData5.append("firstName", firstName);
      console.log(formData5);
  
      const config = {
        headers: {
          "Content-Type": " multipart/form-data",
        },
      };
  
      const res = await axios.post(
        "https://pratik-agro-backend.vercel.app/AddAboutTeamimg",
        formData5,
        config
      );
  
      console.log(res);
    };
    //get image
  
    const getUserData5 = async () => {
      const res2 = await axios.get("https://pratik-agro-backend.vercel.app/getAboutTeamImg", {
        headers: {
          "Content-Type": " application/json",
        },
      });
      if (res2.data.status === 401 || !res2.data) {
        console.log("error");
      } else {
        setnewdata5(res2.data.getImage);
      }
    };
    useEffect(() => {
      getUserData5();
    }, []);
   
  //delete data
  const deleteimage = async (id) => {
   
    const res5 = await fetch(`https://pratik-agro-backend.vercel.app/deletedata5/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const deleteStud = await res5.json();
    console.log(deleteStud);
    if (res5.status === 422 || !deleteStud) {
      console.log("error");
    } else {
      getUserData5();
    }
  
  };
  return (
    <div  className="content">
   <div className="mt-2 mb-1 d-flex justify-content-between align-items-center">
        <i>
          <h2>Team</h2>
        </i>
       <div>
     
       <BellNotifiaction />
       <Link
          type="button"
          to="/Addhomeimage"
          className="btn btn-light shadow addimage "
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          Add Image
        </Link>
       </div>
        
        
      </div>
      <div className=" container text-end mt-5">
        {/* <Link  to="/Addhomeimage"className="btn btn-success "> Add Data</Link> */}
        
        <div
          class="modal fade "
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog ">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">
                  Team Image
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form>
                  <div>
                    
                      <p style={{float:'left'}}>Designation:-</p>
                    
                    <input
                      type="text"
                      name="fname5"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setData5}
                    />

                       <p style={{float:'left'}}>Name:-</p>
                    <input
                      type="text"
                      name="firstName"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                       onChange={setData9}
                    />

                    <div>
                      <p style={{float:'left'}}>Add Your Image:-</p>
                    </div>
                    <input
                      type="file"
                      name="photo5"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      onChange={setimgfile}
                    />
                    <button
                      type="submit"
                      className="btn btn-primary mt-5"
                      onClick={adduserData5}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="outer-wrapper">
    <div class="table-wrapper">
      <table class="table  mt-5">
        <thead className="bg-dark text-white ">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Key People</th>
            <th scope="col">Designation</th>
            <th scope="col">Name</th>
            <th scope="col">Uploaded Date</th>
            <th scope="col">Action</th>
            
          </tr>
        </thead>
        <tbody>
          {newdata5.length>0?newdata5.map((el,id) => {
            console.log(el)
            return (
              <>
                <tr>
                  <th scope="row mt-5">{id+1}</th>
                  <td><img src={el.teamimg} alt='img'  style={{'width':'70px',textAlign:"center",margin:'auto',cursor:"pointer"}}onClick={() => handleImageClick(el.teamimg)}/></td>
                  <td>{el.fname5}</td>
                  <td>{el.firstName}</td>
                  {/* <td>{el.fname5}</td> */}
                  <td>{el.date}</td>
                  {/* <td>
                    <NavLink to={`/Edit/${el._id}`}><i className="bi bi-pencil-square p-4 shadow"  ></i></NavLink>
                    <i class="bi bi-archive-fill p-4 shadow" onClick={()=>deleteimage(el._id)}></i>
                  </td> */}
                  <td>
                        <button type="button" class="btn btn-outline-dark "><NavLink to={`/Team_member_Edit/${el._id}`}><i className="bi bi-pencil-square "  ></i></NavLink></button>
                        <button type="button" class="btn btn-outline-dark "><i class="bi bi-archive-fill " onClick={()=>deleteimage(el._id)}></i></button>
                  </td>
                </tr>
              </>
            );
          }):"Loading..."
          } 
        </tbody>
        <Modal isOpen={isModalOpen} onRequestClose={handleCloseModal} style={{ content: { width: '50%', height: '50%', margin: 'auto', backgroundColor: 'white' } }}>
     <button onClick={handleCloseModal} className="btn btn-danger"><i class="bi bi-x-lg"></i></button>
  <div className='text-center mt-5'>
    <img src={selectedImage} alt="img" style={{width: '30%', height: '35%%'}} className='text-center' />
  </div>
  
</Modal>
      </table>
      </div>
      </div>
    </div>
  )
}